var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.817 21.7575C16.6491 21.7575 21.377 17.0361 21.377 11.212C21.377 5.38794 16.6491 0.66658 10.817 0.66658C4.98485 0.66658 0.256973 5.38794 0.256973 11.212C0.256973 17.0361 4.98485 21.7575 10.817 21.7575Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08878 10.9827L15.2704 7.0624C15.7429 6.89191 16.1557 7.17752 16.0025 7.8911L16.0034 7.89022L14.2698 16.0463C14.1413 16.6245 13.7973 16.7651 13.3159 16.4927L10.6759 14.5497L9.40254 15.7747C9.26174 15.9153 9.14294 16.0339 8.87014 16.0339L9.05758 13.351L13.9504 8.93685C14.1633 8.74967 13.9029 8.64422 13.6221 8.83052L7.57566 12.6322L4.9691 11.8202C4.40326 11.6409 4.39094 11.2551 5.08878 10.9827V10.9827Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.12,
    height: 21.0909,
    fill: "white",
    transform: "translate(0.256973 0.66658)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBlue);
export default __webpack_public_path__ + "static/media/telegram-blue.c6dd5dc2a52f2fff8d4572ed4a10e8fc.svg";
export { ForwardRef as ReactComponent };